import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect,
  useRef,
} from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { TabContext } from "@mui/lab";
import Footer from "src/features/layout/Footer";
import { StyleSettings } from "src/styles/StyleSettings";
import { fnSave } from "@shared/api/restApi";
import { global } from "@shared/libs/Global";
import { Settings, Search, Download } from "@mui/icons-material";
import { showPopupModal } from "@widgets/CommonModal";
import DesignerMenuEdit from "./DesignerMenuEdit";
import TemplateEtc from "./Templates/TemplateEtc";
import { fnGetDataSet } from "@shared/api/restApi";
import DesignerTree, { DesignerNode, DesignerTreeRef } from "./DesignerTree";
import { showDialog } from "@widgets/CommonDialog";
import DesignerQueryEdit from "./DesignerQueryEdit";
import axios from "axios";
import JSZip from "jszip";
import { saveAs } from "file-saver";

interface Props {
  loadData?: any;
  menuOptions?: any;
  noIssue?: string;
  cdMenu?: string;
}

interface VisibleState {
  [key: string]: boolean;
}

interface TemplateInfo {
  label: string;
  key: string;
  type: React.ComponentType<{ loadData: any; ref: any }>;
}

type ColumnInfo = {
  column_name: string;
  data_type: string;
  character_maximum_length: number | null;
  numeric_precision: number | null;
  numeric_scale: number | null;
  is_nullable: string;
  is_primary_key: "YES" | "NO";
  column_default: string | null;
};

const MainDrawing = forwardRef(
  ({ loadData, menuOptions, noIssue, cdMenu }: Props, ref) => {
    const [visible, setVisible] = useState<VisibleState>({});
    const tabHeight = "50px";
    const width = 250;
    const [nodes, setNodes] = useState<DesignerNode[]>([
      { id: "1", title: "main", type: "main", parentId: null, order: 1 },
      { id: "2", title: "mainDiv", type: "maindiv", parentId: "1", order: 2 },
    ]);
    const [slipData, setSlipData] = useState<any>();
    const [saveTables, setSaveTables] = useState<any[]>([]);
    const [query, setQuery] = useState<string>("");
    const componentRef = useRef<any>(null);
    const treeRef = useRef<DesignerTreeRef>(null);
    const { userInfo } = global();

    const controls: any[] = [
      { label: "div", key: "div" },
      { label: "조회조건", key: "SearchPanel" },
      { label: "그리드", key: "SnGrid" },
      { label: "탭", key: "SnTab" },
      { label: "프리폼", key: "SnForm" },
      { label: "파일업로드", key: "SnFileUploadBox" },
    ];

    useEffect(() => {
      setNodes((prev) => loadData?.nodes || prev);
    }, [loadData]);
    useImperativeHandle(ref, () => ({
      downLoadFront,
      downLoadBack,
      downLoadLayout,
      save,
      deploydev,
      deploy,
    }));

    const deploydev = async () => {
      try {
        if (cdMenu === "") {
          await showDialog(
            "alter",
            "개발서버에 없는 메뉴 코드입니다. " +
              "\n메뉴 등록 후 진행해주세요." +
              "\n\n[메뉴등록순서]" +
              "\n1. 업무서버의 노츠메뉴관리에서 메뉴 등록" +
              "\n2. 개발서버의 회사메뉴관리에서 메뉴동기화 버튼 클릭 후 메뉴 권한 할당" +
              "\n3. 그룹메뉴관리 또는 사용자메뉴관리에서 권한 추가"
          );
          return;
        }
        const getData = componentRef.current.getSaveData();
        console.log(getData.headerInfo);
        const params = {
          search: getData.formControlData,
          formgridcolumn: getData.columns,
          formctrl: getData.formControls,
          headerctrl: getData.headerInfo,
          cdMenu: cdMenu,
          query: query,
        };
        const response = await axios.post(
          "http://183.111.205.170:7003/snotes/DESIGNER_DEPLOY",
          params,
          {
            headers: {
              Authorization: "f5pjbv4xl6cn1awryg3s2km7qdu0htei",
              "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
            },
          }
        );
        await showDialog("success", "배포되었습니다");
      } catch (error) {
        console.error("API 호출 실패1", error);
        await showDialog("error", "개발서버와의 통신 실패");
        return;
      }
    };

    const deploy = async () => {
      try {
        if (cdMenu === "") {
          await showDialog(
            "alter",
            "개발서버에 없는 메뉴 코드입니다. " +
              "\n메뉴 등록 후 진행해주세요." +
              "\n\n[메뉴등록순서]" +
              "\n1. 업무서버의 노츠메뉴관리에서 메뉴 등록" +
              "\n2. 개발서버의 회사메뉴관리에서 메뉴동기화 버튼 클릭 후 메뉴 권한 할당" +
              "\n3. 그룹메뉴관리 또는 사용자메뉴관리에서 권한 추가"
          );
          return;
        }
        const getData = componentRef.current.getSaveData();

        const params = {
          search: getData.formControlData,
          formgridcolumn: getData.columns,
          formctrl: getData.formControls,
          headerctrl: getData.headerInfo,
          cdMenu: cdMenu,
          query: query,
        };

        await fnSave("DESIGNER_DEPLOY", params, "배포되었습니다");
      } catch (error) {
        console.error("API 호출 실패1", error);
        await showDialog("error", "개발서버와의 통신 실패");
        return;
      }
    };

    const getMessage = (type: string, message: string) => {
      let returnMsg: string = message;
      switch (type) {
        case "success":
          returnMsg = "[성공] " + returnMsg;
          break;
        case "alter":
          returnMsg = "[경고] " + returnMsg;
          break;
        case "error":
          returnMsg = "[오류] " + returnMsg;
          break;
      }
      return returnMsg;
    };

    const save = async () => {
      if (!componentRef || !componentRef.current) return;
      const getData = componentRef.current.getSaveData();
      const visibleKey = Object.keys(visible)[0];

      const mergedData = {
        ...getData,
        slipData: slipData ?? {},
        nodes: nodes,
        query: query,
        saveTables: saveTables,
      };
      const SaveData = {
        design: {
          insert: [
            {
              cd_firm: userInfo.cd_firm,
              no_issue: noIssue || "TEST_0001",
              cd_menu: cdMenu || "test",
              js_setting: mergedData,
              cd_template: "test",
            },
          ],
        },
      };

      await fnSave("DESIGNER_SAVE_01", SaveData);
    };

    const downLoadLayout = async () => {
      const getData = componentRef.current.getSaveData();

      const blob = new Blob([JSON.stringify(getData.layoutConfig, null, 2)], {
        type: "text/plain;charset=utf-8",
      });
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `${cdMenu}.json`;
      a.click();

      URL.revokeObjectURL(url);
    };

    const downLoadFront = async () => {
      const visibleKey = Object.keys(visible)[0];
      const getData = await componentRef.current.getSaveData();

      fetch(`/templates/front/${visibleKey}.txt`)
        .then((res) => res.text())
        .then((data) => {
          let txt = data;
          if (cdMenu) {
            txt = txt.replace(`${visibleKey}_01`, `${cdMenu.toLowerCase()}_01`);
            txt = txt.replace(`${visibleKey}_SAVE_01`, `${cdMenu}_SAVE_01`);
            txt = txt.replaceAll(`${visibleKey}`, `${cdMenu}`);
          }
          if (getData.gridSettings) {
            Object.keys(getData.gridSettings).forEach((key) => {
              txt = txt.replace(
                `@${key}Title`,
                `"${getData.gridSettings[key].title}"`
              );
              txt = txt.replace(
                `@${key}SaveTable`,
                `${getData.gridSettings[key].table}`
              );
              txt = txt.replace(
                `@${key}InitData`,
                JSON.stringify(getData.gridSettings[key].defaultValue).replace(
                  /"/g,
                  ""
                )
              );
              txt = convertButton(txt, getData.gridSettings[key].button, key);
            });
            txt = convertSlipAndFilter(txt, getData.gridSettings);
          }
          const blob = new Blob([txt], { type: "text/plain;charset=utf-8" });
          const url = URL.createObjectURL(blob);

          const a = document.createElement("a");
          a.href = url;
          a.download = `${cdMenu || visibleKey}.tsx`;
          a.click();

          URL.revokeObjectURL(url);
        });
    };

    const getColumnsInfo = async (tablename: string) => {
      try {
        const search = {
          queryId: "getColumnsInfo",
          id: "DesignerMapper",
          params: {
            table_name: tablename,
          },
        };
        const data: any = await fnGetDataSet(search);
        return data[0];
      } catch (error) {}
    };

    const downLoadBack = async () => {
      const zip = new JSZip();

      const tableFiles = [
        "Table",
        "TableDto",
        "TableInterface",
        "TableMapper",
        "TablePk",
        "TableRepository",
      ];

      const menuFiles = ["MenuController", "MenuService", "MenuServiceImpl"];

      // =========================
      // ✅ 1. 테이블 관련 파일들
      // =========================
      const tableinfo: Record<string, any> = {};

      for (const table of saveTables) {
        const rtn = await getColumnsInfo(table);
        tableinfo[table] = rtn;
      }
      for (const table of saveTables) {
        for (const file of tableFiles) {
          const res = await fetch(`/templates/back/${file}.txt`);
          let txt = await res.text();
          let filename = "";

          txt = txt.replaceAll(`@tablename`, table);
          txt = txt.replaceAll(`@cdmodule`, table.substring(0, 3));
          txt = txt.replaceAll(`@cdmenu`, cdMenu || "");
          txt = txt.replaceAll(`@lower_cdmenu`, cdMenu?.toLowerCase() || "");

          if (file === "TableDto" && tableinfo[table]) {
            txt = txt.replaceAll(
              `@columns`,
              generateJavaDtoFields(tableinfo[table])
            );
          }

          if (file === "TableRepository" && tableinfo[table]) {
            txt = txt.replaceAll(`@pkDto`, generatePkDto(tableinfo[table]));
            txt = txt.replaceAll(
              `@pkEntity`,
              generatePkEntity(tableinfo[table])
            );
          }

          if (file === "TablePk" && tableinfo[table]) {
            txt = txt.replaceAll(`@pk`, generatePk(tableinfo[table]));
          }

          if (file === "Table" && tableinfo[table]) {
            txt = txt.replaceAll(
              `@columns`,
              generateJavaFields(tableinfo[table])
            );
            filename = table.toLowerCase();
          } else {
            filename = file.replace("Table", table + "_").toLowerCase();
          }
          new Promise((resolve) => setTimeout(resolve, 500));
          // zip에 추가
          zip.file(`${filename}.java`, txt);
        }
      }

      // =========================
      // ✅ 2. 메뉴 파일 (한 번만)
      // =========================
      for (const file of menuFiles) {
        const res = await fetch(`/templates/back/${file}.txt`);
        let txt = await res.text();
        const module = (cdMenu || "").substring(3, 3);
        txt = txt.replaceAll(`@cdmenu`, cdMenu || "");
        txt = txt.replaceAll(`@cdmodule`, module);
        txt = txt.replaceAll(`@lower_cdmenu`, cdMenu?.toLowerCase() || "");

        const suffix =
          file === "MenuController"
            ? "_controller"
            : file === "MenuService"
              ? "_service"
              : "_serviceImpl";

        const filename = (cdMenu || "").toLowerCase() + suffix;

        if (file === "MenuServiceImpl") {
          const serviceImplData = getServiceImplData(saveTables);
          txt = txt.replaceAll(`@import`, serviceImplData.importText);
          txt = txt.replaceAll(`@final`, serviceImplData.finalText);
          txt = txt.replaceAll(`@list`, serviceImplData.listText);
        }

        zip.file(`${filename}.java`, txt);
      }

      // =========================
      // ✅ 3. zip 다운로드
      // =========================
      const content = await zip.generateAsync({ type: "blob" });
      saveAs(content, "back.zip");
    };

    const mapPostgresTypeToJava = (col: ColumnInfo) => {
      switch (col.data_type) {
        case "character varying":
        case "varchar":
        case "text":
          return "String";
        case "integer":
        case "int":
          return "Integer";
        case "bigint":
          return "Long";
        case "numeric":
        case "decimal":
          return "BigDecimal";
        case "date":
        case "timestamp without time zone":
        case "timestamp with time zone":
          return "Date";
        case "bytea":
          return "byte[]";
        default:
          return "String";
      }
    };

    const generateJavaFields = (columns: ColumnInfo[]) => {
      return columns
        .map((col) => {
          const javaType = mapPostgresTypeToJava(col);
          const isBigDecimal = javaType.includes("BigDecimal");
          const isString = javaType.includes("String");
          let annotations = "";

          if (col.is_primary_key === "YES") {
            annotations += "    @Id\n";
          }

          if (javaType === "byte[]") {
            annotations += "    @JdbcTypeCode(SqlTypes.VARBINARY)\n";
            annotations += `    @Column(name = "${col.column_name}", columnDefinition = "bytea")\n`;
          } else if (
            javaType === "BigDecimal" &&
            col.numeric_precision != null &&
            col.numeric_scale != null
          ) {
            annotations += `    @Column(name = "${col.column_name}", nullable = ${
              col.is_nullable === "YES" ? "true" : "false"
            }, precision = ${col.numeric_precision}, scale = ${col.numeric_scale})\n`;
          } else if (javaType === "Date") {
            annotations += `    @Column(name = "${col.column_name}")\n`;
          } else {
            annotations += `    @Column(name = "${col.column_name}", ${
              col.is_nullable === "YES" ? "nullable = true" : "nullable = false"
            }${col.character_maximum_length ? `, length = ${col.character_maximum_length}` : ""})\n`;
          }

          const defaultValue =
            col.is_nullable === "NO" && isBigDecimal
              ? " = BigDecimal.ZERO"
              : col.is_nullable === "NO" &&
                  isString &&
                  col.column_name.startsWith("yn_")
                ? ' = "Y"'
                : col.column_default
                  ? ` = ${col.column_default.replace(/::[\w\s]+/, "")}`
                  : "";

          return `${annotations}    private ${javaType} ${col.column_name}${defaultValue};`;
        })
        .join("\n\n");
    };

    const generatePkDto = (columns: ColumnInfo[]) => {
      return columns
        .filter((col) => col.is_primary_key === "YES")
        .map((col) => {
          const name = col.column_name;
          return `dto.get${name.charAt(0).toUpperCase()}${name.slice(1)}()`;
        })
        .join(", ");
    };

    const generatePkEntity = (columns: ColumnInfo[]) => {
      return columns
        .filter((col) => col.is_primary_key === "YES")
        .map((col) => {
          const name = col.column_name;
          return `entity.get${name.charAt(0).toUpperCase()}${name.slice(1)}()`;
        })
        .join(", ");
    };

    const mapColumnToJavaType = (col: any) => {
      const type = col.data_type.toLowerCase();
      const isPk = col.is_primary_key === "YES";
      const isNullable = col.is_nullable === "YES";

      // =========================
      // 1. 기본 자바 타입 결정
      // =========================
      let javaType = "String";

      if (type.includes("char") || type.includes("text")) javaType = "String";
      else if (type.includes("int4")) javaType = "Integer";
      else if (type.includes("int2")) javaType = "Short";
      else if (type.includes("int8") || type.includes("bigint"))
        javaType = "Long";
      else if (type.includes("int")) javaType = "Long";
      else if (type.includes("numeric") || type.includes("decimal"))
        javaType = "BigDecimal";
      else if (type.includes("double") || type.includes("float8"))
        javaType = "Double";
      else if (type.includes("real") || type.includes("float4"))
        javaType = "Float";
      else if (type.includes("bool")) javaType = "Boolean";
      else if (type.includes("date") || type.includes("time"))
        javaType = "Date";
      else if (type.includes("bytea")) javaType = "byte[]";

      // =========================
      // 2. PK는 무조건 기본 타입
      // =========================
      if (isPk) return javaType;

      // =========================
      // 3. nullable 정책 적용
      // =========================
      // nullable = true  → 그냥 타입
      // nullable = false → JsonNullable<T>
      return isNullable ? javaType : `JsonNullable<${javaType}>`;
    };

    const generateJavaDtoFields = (cols: any[]) => {
      return cols
        .map((col) => {
          const javaType = mapColumnToJavaType(col);
          return `private ${javaType} ${col.column_name};`;
        })
        .join("\n");
    };

    const generatePk = (cols: any[]) => {
      return cols
        .filter((col) => col.is_primary_key === "YES")
        .map((col) => {
          const javaType = mapColumnToJavaType(col);
          return `private ${javaType} ${col.column_name};`;
        })
        .join("\n");
    };

    const convertButton = (txt: string, value: string, key: string) => {
      let rtn = txt;
      if (!value) {
        rtn = rtn.replace(`@on${key}BtnsClick`, "");
        rtn = rtn.replace(`@${key}Header`, "");
        return rtn;
      }
      const buttonLabels = value
        .split(",")
        .map((label) => label.trim())
        .filter((label) => label);
      if (value == "") {
        rtn = rtn.replace(`@on${key}BtnsClick`, "");
        rtn = rtn.replace(`@${key}Header`, "");
      } else {
        rtn = rtn.replace(
          `@on${key}BtnsClick`,
          `const on${key.replace("g", "G")}BtnsClick = (id: string) => {
            switch (id) {
              @${key}Case
            }
          };`
        );

        let header: string = "header={";
        let caseId: string = "";
        buttonLabels.map((label) => {
          header =
            header +
            `<SnButton
              key={"${label}"}
              text={"${label}"}
              onClick={() => on${key.replace("g", "G")}BtnsClick("${label}")}
            />`;
          caseId =
            caseId +
            `case "${label}":
              break;`;
        });
        header = header + "}";
        rtn = rtn.replace(`@${key}Header`, header);

        rtn = rtn.replace(`@${key}Case`, caseId);
      }

      return rtn;
    };

    const convertSlipAndFilter = (txt: string, gridSettings: any) => {
      if (!slipData) return txt.replace(`@Slip`, "");

      let gridApis: string = "[";
      let gridInserts: string = "[";
      let saveFIlters: string = "";
      Object.keys(gridSettings).forEach((key) => {
        gridApis = gridApis + `${key}ApiRef,`;
        gridInserts = gridInserts + `${key}Inserts,`;
        if (
          gridSettings[key].filterColumns != null &&
          gridSettings[key].filterColumns != undefined &&
          gridSettings[key].filterColumns.length > 0
        ) {
          let saveColumns: string = "";
          let focusedColumns: string = "";
          let cellValueChangedColumns: string = "";
          let ifColumns: string = "";
          gridSettings[key].filterColumns.forEach((col: string) => {
            if (col === slipData?.column)
              saveColumns = saveColumns + `${col}: noSlip,`;
            else {
              saveColumns =
                saveColumns + `${col}: ${getPrevGrid(key)}FocusedRow.${col},`;
            }
            focusedColumns =
              focusedColumns + `${col}: ${getPrevGrid(key)}FocusedRow.${col},`;
            cellValueChangedColumns =
              cellValueChangedColumns + `${col}: data.rowData.${col},`;
            ifColumns = ifColumns + `"${col}",`;
          });
          saveFIlters =
            saveFIlters +
            `${key}ApiRef.current.applyFilters({ ${saveColumns} });`;
          if (!focusedColumns || focusedColumns == "") {
            txt = txt.replace(`@${key}FocusedRowChangedFilter`, "");
          } else {
            txt = txt.replace(
              `@${key}FocusedRowChangedFilter`,
              `${key}ApiRef.current.applyFilters({ ${focusedColumns} });`
            );
          }
          if (!cellValueChangedColumns || cellValueChangedColumns === "") {
            txt = txt.replace(`@${key}EditValueChangedFilter`, "");
          } else {
            const replaceTxt = `if ([${ifColumns}].includes(data.colId)) {
              ${key}ApiRef.current.applyFilters({ ${cellValueChangedColumns} });
            }`;
            txt = txt.replace(`@grid2EditValueChangedFilter`, replaceTxt);
          }
        }
      });

      gridApis = gridApis + "]";
      gridInserts = gridInserts + "]";
      const rtn = `const slipparams = {
              cd_module: "${slipData?.module.cd_module}",
              no_line: ${slipData?.line.no_line},
              cd_prefix: "${slipData?.prefix}",
              dt: grid1Inserts[0]?.${slipData?.dt},
              girdrefs: ${gridApis},
              inserts: ${gridInserts},
              cd_column: "${slipData?.column}",
            };
            const noSlip = await applySlip(slipparams);
            ${saveFIlters}`;
      return txt.replace(`@Slip`, rtn);
    };

    function getPrevGrid(key: string): string {
      const match = key.match(/grid(\d+)/); // grid 뒤 숫자 추출
      if (!match) return key; // 숫자 없는 경우 그대로 반환
      const num = parseInt(match[1], 10);
      return `grid${num - 1}`;
    }

    /**
     * serviceImpl 파일에서 치환 시 사용할 텍스트 추출 메서드
     * 정렬을 다 맞춰 놨으니 space & tap 사용 시 확인해주세요 - 현지
     * @param tableList 메뉴에서 사용할 테이블 리스트
     */
    function getServiceImplData(tableList: string[]) {
      // 1. import 구문
      const imports = tableList
        .map(
          (table) =>
            `import com.g2sysnet.snotes.entity.${table.substring(0, 3)}.${table}.${table};
import com.g2sysnet.snotes.entity.${table.substring(0, 3)}.${table}.${table}_dto;
import com.g2sysnet.snotes.entity.${table.substring(0, 3)}.${table}.${table}_repository;`
        )
        .join("\n");

      // 2. 상단 변수 선언 구문
      const finals = tableList
        .map(
          (table) => `private final ${table}_repository ${table}_repository;`
        )
        .join("\n\n\t");

      // 3. 선언부 (순서대로)
      const declarations = tableList
        .map(
          (
            table
          ) => `Map<String, Object> ${table}_map = (Map<String, Object>) map.get("${table}");
        List<${table}> ${table}_insertList = objectMapper.extractList(${table}_map, "insert", new TypeReference<>() {});
        List<${table}_dto> ${table}_updateList = objectMapper.extractList(${table}_map, "update", new TypeReference<>() {});
        List<${table}> ${table}_deleteList = objectMapper.extractList(${table}_map, "delete", new TypeReference<>() {});`
        )
        .join("\n\n\t\t");

      // 4. delete (역순)
      const deletes = [...tableList]
        .reverse()
        .map(
          (
            table
          ) => `        if (${table}_deleteList != null && !${table}_deleteList.isEmpty()) {
            ${table}_repository.${table}_d(${table}_deleteList);
        }`
        )
        .join("\n");

      // 5. insert (순서대로)
      const inserts = tableList
        .map(
          (
            table
          ) => `        if (${table}_insertList != null && !${table}_insertList.isEmpty()) {
            ${table}_repository.${table}_i(${table}_insertList);
        }`
        )
        .join("\n");

      // 6. update (순서대로)
      const updates = tableList
        .map(
          (
            table
          ) => `        if (${table}_updateList != null && !${table}_updateList.isEmpty()) {
            ${table}_repository.${table}_u(${table}_updateList);
        }`
        )
        .join("\n");

      return {
        importText: imports,
        finalText: finals,
        listText: [declarations, deletes, inserts, updates].join("\n\n"),
      };
    }

    function addControls(type: string) {
      const focusedItem = treeRef.current?.getFocusedItem();
      const selected = treeRef.current?.getSelectedItems() ?? [];
      const rawId = selected?.[0];
      let parentId = "2";
      const node = nodes.find((c) => c.id === String(rawId));
      if (type === "div") {
        parentId =
          node?.type === "main" || node?.type === "div" ? String(rawId) : "2";
      } else {
        if (rawId != null && node?.type == "div") {
          parentId = String(rawId);
        }
      }

      setNodes((prev) => {
        // 1️⃣ 마지막 id + 1
        const maxId = Math.max(
          ...prev.map((n) => Number(n.id)).filter((n) => !isNaN(n)),
          0
        );
        const newId = String(maxId + 1);

        // 2️⃣ controls 에서 label 찾기
        const control = controls.find((c) => c.key === type);
        const label = control?.label ?? type;

        // 3️⃣ 같은 타입 개수 → 번호
        const sameTypeCount = prev.filter(
          (n) => n.type === type || n.subType === type
        ).length;
        const order = prev.filter((n) => n.parentId === parentId).length;

        const newNode: DesignerNode = {
          id: newId,
          type: type as any, // NodeType 쓰면 NodeType으로
          parentId: parentId,
          order: order,
          title: `${label}${sameTypeCount + 1}`,
        };
        if (type === "SearchPanel") {
          const SearchPanel: DesignerNode = {
            id: newId,
            type: type as any, // NodeType 쓰면 NodeType으로
            parentId: "1",
            order: 1,
            title: `${label}`,
          };
          if (sameTypeCount > 0) return [...prev];
          return [SearchPanel, ...prev];
        } else if (type === "SnTab") {
          const tab: DesignerNode = {
            id: newId,
            type: type as any, // NodeType 쓰면 NodeType으로
            parentId: parentId,
            order: order,
            title: `${label}${sameTypeCount + 1}`,
          };
          const GridCount = prev.filter(
            (n) => n.type === "SnGrid" || n.subType === "SnGrid"
          ).length;
          const tabpage: DesignerNode = {
            id: String(maxId + 2),
            type: "TabPage", // NodeType 쓰면 NodeType으로
            parentId: newId,
            order: 1,
            title: `그리드${GridCount + 1}`,
            subType: "SnGrid",
            subTitle: `그리드${GridCount + 1}`,
          };
          return [...prev, tab, tabpage];
        } else {
          return [...prev, newNode];
        }
      });
    }

    function onChange(changes: DesignerNode[]) {
      setNodes(changes);
    }
    return (
      <Box sx={{ display: "flex", height: "calc(100vh - 60px)", border: 0 }}>
        <div className="flex justify-between w-full h-full">
          <div className="w-[280px] h-full bg-blue-500 text-white shadow-lg z-50">
            <div className="h-[400]">
              <DesignerTree
                ref={treeRef}
                initialNodes={nodes}
                onChange={onChange}
              ></DesignerTree>
            </div>
            <ul className="p-2 space-y-2">
              {controls.map((ctr) => (
                <div
                  key={ctr.key}
                  className="px-3 py-2 bg-blue-600 rounded hover:bg-blue-400 transition cursor-move"
                  onClick={() => {
                    addControls(ctr.key);
                  }}
                >
                  {ctr.label}
                </div>
              ))}
            </ul>
          </div>
          <div className="flex flex-col h-full w-full">
            <Box
              sx={{
                flex: 1,
                backgroundColor: "#f5f5f5",
                height: tabHeight, // Full viewport height
                width: `calc(100vw - ${width}px)`,
              }}
            >
              <TabContext value={0}>
                {/* Tabs */}
                <Box
                  sx={{
                    borderBottom: 1,
                    borderColor: "rgb(186,191,199)",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{ zIndex: 1, width: "100%", overflowX: "hidden" }}
                  >
                    {/* 왼쪽: TabList */}
                    <Tabs
                      value={0}
                      variant="scrollable"
                      scrollButtons="auto"
                      sx={{
                        ".MuiTab-root": {
                          color: "white", // 모든 탭의 글자색을 흰색으로 설정
                          backgroundColor: "rgb(151, 151, 151)", // 비활성화된 탭의 배경색
                          "&.Mui-selected": {
                            backgroundColor: "rgb(11, 12, 105)", // 활성화된 탭의 배경색
                            color: "white", // 활성화된 탭의 글자색을 흰색으로 설정
                          },
                        },
                        ".MuiTabs-indicator": {
                          display: "none", // 인디케이터를 숨김
                        },
                        flexShrink: 0, // 탭이 축소되지 않도록 설정
                      }}
                    >
                      <Tab
                        key={"tab1"}
                        value={0}
                        sx={{
                          width: 130,
                          padding: "0px 7px !important", // Tab 자체에 패딩
                          fontSize: `${StyleSettings.font}px`,
                          marginTop: "13px",
                          marginLeft: "10px",
                          minHeight: "35px",
                        }}
                        label={
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              width: "100%",
                            }}
                          >
                            <Box
                              sx={{
                                display: "inline-block", // 텍스트 영역을 인라인 블록으로 설정
                                overflow: "hidden", // 넘치는 텍스트를 숨기기
                                textOverflow: "ellipsis", // 넘칠 때 ... 표시
                                whiteSpace: "nowrap", // 텍스트 줄 바꿈 방지
                                width: "100%",
                                fontWeight: "bold",
                                textAlign: "left",
                              }}
                            >
                              {"신규"}
                            </Box>
                          </Box>
                        }
                      />
                    </Tabs>
                  </div>
                  <Box
                    sx={{
                      width: 40,
                      textAlign: "right",
                      marginRight: "5px",
                    }}
                  >
                    <Download
                      fontSize="large"
                      className="w-16 h-16 text-blue-500 hover:text-blue-700 transition-colors cursor-pointer shadow-lg rounded-full border-2 border-blue-300 bg-white"
                      onClick={async () => {}}
                    />
                  </Box>
                  <Box
                    sx={{
                      width: 40,
                      textAlign: "right",
                      marginRight: "5px",
                    }}
                  >
                    <Search
                      fontSize="large"
                      className="w-16 h-16 text-blue-500 hover:text-blue-700 transition-colors cursor-pointer shadow-lg rounded-full border-2 border-blue-300 bg-white"
                      onClick={async () => {
                        const getData = componentRef.current.getSaveData();
                        const component = (
                          <DesignerQueryEdit
                            data={getData}
                            cdMenu={cdMenu}
                            query={query || ""}
                          />
                        );
                        const result = await showPopupModal({
                          title: `쿼리설정`,
                          children: component,
                          width: "1200px",
                          height: "1000px",
                        });
                        if (!result || result === "close") return;
                        setQuery(result[0]);
                      }}
                    />
                  </Box>
                  <Box
                    sx={{
                      width: 50,
                      textAlign: "right",
                      marginRight: "35px",
                    }}
                  >
                    <Settings
                      fontSize="large"
                      className="w-16 h-16 text-blue-500 hover:text-blue-700 transition-colors cursor-pointer shadow-lg rounded-full border-2 border-blue-300 bg-white"
                      onClick={async () => {
                        const component = (
                          <DesignerMenuEdit
                            slipData={slipData}
                            saveTables={saveTables}
                          />
                        );
                        const result = await showPopupModal({
                          title: `메뉴설정`,
                          children: component,
                          width: "600px",
                          height: "500px",
                        });
                        if (!result || result === "close") return;
                        setSlipData(result[0]);
                        setSaveTables(result[1]);
                      }}
                    />
                  </Box>
                </Box>

                <div
                  className="tabs"
                  key={0}
                  style={{
                    display: "block",
                    height: "calc(100% - 50px)",
                    width: "100%",
                    flex: 1,
                  }}
                >
                  <Box
                    sx={{
                      overflowY: "auto",
                      height: "100%",
                      width: "100%",
                      paddingTop: "5px",
                      paddingBottom: "5px",
                      paddingRight: "20px",
                      paddingLeft: "16px",
                    }}
                  >
                    <div
                      className="h-full flex flex-col"
                      style={{
                        position: "relative",
                        pointerEvents: "auto",
                      }}
                    >
                      <TemplateEtc
                        key={"TemplateEtc"}
                        loadData={loadData}
                        nodes={nodes}
                        ref={componentRef}
                        cdMenu={cdMenu}
                      />
                    </div>
                  </Box>
                </div>
              </TabContext>
            </Box>

            {/* Footer */}
            <Footer />
          </div>
        </div>
      </Box>
    );
  }
);

export default MainDrawing;
